import { ListFilter } from './ListFilter';

export interface ExamEventListFilter extends ListFilter {
  testcentersId: number;
  testId: number;
  includeEvent: number;
  availableForBooking: boolean;
  includeStatistics?: boolean;
}
